import React, { ReactChild, ReactChildren } from 'react';
import { NO_TRANSLATE_CLASSNAME } from './translation.constants';

export interface NoTranslateProps {
    children: ReactChild | ReactChildren;
}

export const NoTranslate = ({ children }: NoTranslateProps) => (
    <div className={NO_TRANSLATE_CLASSNAME}>
        {children}
    </div>
);
